// <copyright file="SVGLoader.js" company="Crafted Media Ltd.">
//     Copyright (c) Crafted Media Ltd. All rights reserved.
//     Created by Chris Warnes
// </copyright>

import { Logger } from './Logger'
import svgService from '../services/svgService'

class SVGLoader {
  constructor (elem) {
    this.svgUrl = elem.getAttribute('data-src')
    this.parent = elem
    this.logger = new Logger('SVG Loader')
    this.service = svgService

    this.logger.log('initialising SVG Loader')
  }

  load () {
    this.logger.log('Retrieving svg symbols.')
    const self = this
    return this.service.getSVG(this.svgUrl, this.logger)
      .then(function (svgs) {
        self.loadSVGs(svgs)
      }, function (err) {
        self.logger.error(`sprite sheet failed to load with error: ${err}`)
      })
      .catch(function (error) {
        self.logger.error(`sprite sheet failed to load with error: ${error}`)
      })
  }

  loadSVGs (svgs) {
    this.parent.innerHTML = svgs

    if (this.parent.firstChild.tagName.toLowerCase() === 'svg') {
      this.parent.firstChild.setAttribute('version', '1.1')
    } else {
      this.parent.innerHTML = ''
      this.logger.error('data expected from sprite sheet was not in the correct format.')
    }
    this.logger.log('spritesheet loaded')
  }
}

const loadSprites = function () {
  const sprites = document.querySelectorAll('.svg-symbols')

  for (const sprite of sprites) {
    const loader = new SVGLoader(sprite)
    loader.load()
  }
}

export {
  SVGLoader,
  loadSprites
}
